var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40.708px",
    height: "32.297px",
    viewBox: "0 5.69 40.708 32.297",
    enableBackground: "new 0 5.69 40.708 32.297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6362E7",
    d: "M21.5,6c7.6-2,14.833,6.167,17.5,10.5c10,15-27.095,29.359-29,16.5C8,19.5,12,8.5,21.5,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.016,32h-4.953l0.031-3.656h4.922c1.229,0,2.266-0.275,3.109-0.828c0.844-0.563,1.479-1.381,1.906-2.453 c0.438-1.072,0.656-2.369,0.656-3.891v-1.109c0-1.167-0.125-2.193-0.375-3.078c-0.24-0.885-0.599-1.63-1.078-2.234 s-1.068-1.057-1.766-1.359c-0.698-0.313-1.5-0.469-2.406-0.469h-5.094V9.25h5.094c1.521,0,2.912,0.26,4.172,0.781 c1.271,0.51,2.37,1.245,3.297,2.203s1.641,2.104,2.141,3.438c0.51,1.323,0.766,2.797,0.766,4.422v1.078 c0,1.615-0.255,3.088-0.766,4.422c-0.5,1.334-1.213,2.479-2.141,3.438c-0.917,0.947-2.016,1.682-3.297,2.203 C26.963,31.744,25.557,32,24.016,32z M21.719,9.25V32h-4.688V9.25H21.719z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 11.5,
    cy: 13.5,
    r: 4.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 5.5,
    cy: 21.5,
    r: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 6,
    cy: 7,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 1.5,
    cy: 15.5,
    r: 1.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 4,
    cy: 11,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFC500",
    cx: 1,
    cy: 8,
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.f010c51a5effdcbe6634e15311a2f709.svg";
export { ForwardRef as ReactComponent };